var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-badge',{attrs:{"id":_vm.id,"variant":_vm.variant}},[_vm._t("icon")],2),_c('b-tooltip',{attrs:{"target":_vm.id}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }